// mixin.js
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      authenticated: "auth/authenticated",
      user: "auth/user",
      company: "auth/company",
      errors: "errors/getErrors",
      status: "errors/getStatus",
      baseUrl: "settings/getBaseUrl",
      mediaUrl: "settings/getMediaUrl",
      rowsPerPage: "settings/getRowsPerPage",
      roleName: "auth/roleName",
    }),
  },
};
